<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="goBack()"> 投票列表 </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">检查投票进度</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div></div>
    </div>
    <div
      class="main_body"
      v-loading="loading"
      :element-loading-text="$config.loadingText"
      :element-loading-spinner="$config.loadingSpinner"
      :element-loading-background="$config.loadingBackground"
    >
      <div class="form_bar">
        <div></div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()">返回投票列表</el-button>
          <el-button type="primary" @click="refresh()" size="small" plain>
            刷新
          </el-button>
        </div>
      </div>
      <div class="form_content">
        <div class="vote_name">
          <div v-html="voteProgress.VoteName"></div>
        </div>
        <el-divider content-position="left">
          未投票评委（{{ voteProgress.NotVoteUserList.length }}）
        </el-divider>
        <div class="not_vote_user_box">
          <div
            class="not_vote_user_box_item"
            v-for="(item, index) in voteProgress.NotVoteUserList"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import voteManageApi from '../../../../api/vote/voteManage'
export default {
  data () {
    return {
      loading: false,
      voteProgress: {
        NotVoteUserList: []
      }
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    getVoteProgress: function () {
      this.loading = true
      voteManageApi.getVoteProgressInfo({
        voteId: this.$route.params.vid
      })
        .then(data => {
          this.voteProgress = data
          this.loading = false
        }).catch(err => {
          this.loading = false
          return err
        })
    },
    refresh: function () {
      this.getVoteProgress()
    }
  },
  created () {
    this.getVoteProgress()
  }
}
</script>
<style lang="less">
.vote_name {
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-weight: 900;
  padding: 10px;
}
.not_vote_user_box {
  margin: 20px;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
.not_vote_user_box_item {
  margin-right: 20px;
  font-weight: 700;
}
.form_content .el-divider__text {
  font-size: 18px;
  font-weight: 900;
}
</style>
